import BodyClassName from "react-body-classname";
import classes from "../classes";
import onDocumentEvent from "./higher-order/on-document-event";
import pure from "./higher-order/pure";
import React from "react";

function stopPropagation(e) {
  e.stopPropagation();
}

export default pure(onDocumentEvent("keyup", onKeyDown, function LightBox({ children, onClose, small, tall, title, wide }) {
  return (
    <BodyClassName className="body--lightbox-is-open">
      <div
        className={classes({
          "lightbox": true,
          "lightbox--is-open": true,
          "lightbox--small": small,
          "lightbox--tall": tall,
          "lightbox--wide": wide
        })}
        onClick={onClose}>
        <div className="lightbox_frame" onClick={stopPropagation}>
          <div className="lightbox_container">
            <div className="lightbox_header">
              <h4 className="lightbox_title">
                {title}
              </h4>

              <button className="lightbox_close" onClick={onClose} type="button">
                <span className="dw-close" />
              </button>
            </div>

            {children}
          </div>
        </div>
      </div>
    </BodyClassName>
  );
}));

function onKeyDown(e, props) {
  if (e.keyCode === 27) {
    props.onClose(e);
  }
}
